"use client"

import { useEffect } from "react"

interface TrackingProviderProps {
  locale: string
  country: string
  countryName: string
}

/**
 * 产品页埋点：页面加载时推送 product_page_view 事件
 * 并在页面中注入点击追踪的事件委托
 */
export default function TrackingProvider({ locale, country, countryName }: TrackingProviderProps) {
  useEffect(() => {
    const w = window as typeof window & { dataLayer?: Record<string, unknown>[] }
    if (!w.dataLayer) w.dataLayer = []

    // product_page_view — include URL search params for full context
    const params = new URLSearchParams(window.location.search)
    w.dataLayer.push({
      event: "product_page_view",
      locale,
      country,
      countryName,
      page: window.location.pathname,
      day: params.get("day") || "",
      dataMode: params.get("dataMode") || "",
      quota: params.get("quota") || "",
    })

    // 事件委托：追踪带 data-track 属性的点击
    const handler = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest("[data-track]") as HTMLElement | null
      if (!target) return

      const event = target.getAttribute("data-track")
      const section = target.getAttribute("data-track-section") || ""
      const href = target.getAttribute("href") || ""

      w.dataLayer?.push({
        event: event || "click_internal_link",
        locale,
        country,
        sourceSection: section,
        targetUrl: href,
      })
    }

    document.addEventListener("click", handler)
    return () => document.removeEventListener("click", handler)
  }, [locale, country, countryName])

  return null
}
